const page2 = {
  id: 2,
  title: "Усадьба Сназиных-Тормасовых",
  location: "с. Ивановское, Вышневолоцкий район, Тверская область",
  years: "Годы постройки: 1811–1914",
  text: "Усадьбу основал генерал-майор Иван Сназин. Он построил двухэтажный дом и церковь с колокольней. После смерти Сназина его дети продолжали застраивать территорию и поднимать хозяйство.<br/><br/>Поместье расцвело при внучке Ивана Сназина, Софье, и её муже — Владимире фон Гаслере. В 1914 году он отстроил на территории имения дворец-замок в псевдоготическом стиле, затем открыл земскую школу и сделал оранжерею, из которой поставляли фрукты в Елисеевский магазин в Санкт-Петербурге.<br/><br/>После революции усадебный комплекс переоборудовали под дом отдыха, поставили новые санаторные корпуса. Позже имение переименовали в «Голубые озера» — в честь двух местных озёр Сестрино и Волчино.",
  info: {
    stateTitle: "Что с усадьбой сейчас",
    stateText: "В середине 1990-х усадьба оказалась никому не нужна. До построек добрались мародёры: на металлолом пошла кровля и кованые калитки. Внутри здания рушатся перекрытия, стены, крыша. Периодически на территорию приходят волонтёры, которые убирают мусор, расчищают заросли. Но для сохранения архитектурного памятника этого недостаточно.",
  },
  image: "snazin",
  author: 'николай будишевский',
  video: "//ok.ru/videoembed/6576869345851",
  comment: {
    author: "Роман Ушаков",
    photo: "roman.jpg",
    text: "Усадьба находится не только в очень красивом месте — в лесу на берегу озера, но и в очень удобном с точки зрения логистики — между Москвой и Петербургом. Будем надеяться, что этот усадебный комплекс обретёт нового ответственного собственника, который сможет восстановить здания и аккуратно приспособить их под современное использование."
  },
  slider: ["snazin/1.png"],
  color: "#2C8589",
  textColor: "#F9C03F",
  helpLink: "https://fondvnimanie.ru/",
  coordinates: [5.73, 1.65]
}

export { page2 };
